var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row justify-content-end",
      staticStyle: { "flex-wrap": "nowrap" }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex align-items-center justify-content-end mr-2 mb-md-2"
        },
        _vm._l(_vm.company.tags, function(tag) {
          return _c("tag-color", {
            key: tag.id,
            attrs: {
              color: tag.color.name,
              name: tag.name,
              "input-class": "mr-1"
            }
          })
        })
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "visibility-box p-3 rounded border",
          class: {
            "border-green": _vm.company && _vm.company.mod_status_id === 5,
            "border-red": _vm.company && _vm.company.mod_status_id === 3
          }
        },
        [
          _c("div", { staticClass: "col-6 px-0" }, [
            _vm.company && _vm.company.mod_status_id === 2
              ? _c("span", { staticClass: "visible-info" }, [
                  _vm._v("\n        Request sent\n      ")
                ])
              : _vm.company && _vm.company.mod_status_id === 3
                ? _c("span", { staticClass: "visible-info" }, [
                    _c("i", {
                      staticClass: "fa fa-times-circle",
                      attrs: { "aria-hidden": "true" }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "tippy-popup tippy-info",
                        on: {
                          mouseover: function($event) {
                            _vm.showVisibilityTooltip = true
                          },
                          mouseout: function($event) {
                            _vm.showVisibilityTooltip = false
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-info-circle" })]
                    ),
                    _vm._v(" "),
                    _vm.showVisibilityTooltip
                      ? _c(
                          "div",
                          { staticClass: "popover tippy-info-popover" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.company && _vm.company.review_notification
                                ) +
                                "\n        "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v("\n        Request denied\n      ")
                  ])
                : _vm.company && _vm.company.mod_status_id === 5
                  ? _c("span", { staticClass: "visible-info" }, [
                      _c("i", {
                        staticClass: "fa fa-check-circle",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v("\n        Listed on mod24\n      ")
                    ])
                  : _vm.company && _vm.company.mod_status_id === 1
                    ? _c("span", { staticClass: "visible-info" }, [
                        _vm._v("Appear on mod24 website")
                      ])
                    : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-6 text-right px-0" }, [
            _vm.company && _vm.company.mod_status_id === 5
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary btn-visible px-2",
                    attrs: { type: "button" },
                    on: { click: _vm.cancelVisibility }
                  },
                  [_vm._v("\n        Cancel visibility\n      ")]
                )
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _vm.showApprovalModal
        ? _c(
            "modal",
            {
              attrs: { container: "l-modal-container-sm" },
              on: {
                close: function($event) {
                  _vm.showApprovalModal = false
                }
              }
            },
            [
              _c("template", { slot: "header" }, [_vm._v(" ")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex flex-column align-items-center px-3",
                  attrs: { slot: "body" },
                  slot: "body"
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("../../assets/img/submit-request.svg"),
                      alt: "Tier select"
                    }
                  }),
                  _vm._v(" "),
                  _c("h4", { staticClass: "text-center mt-4" }, [
                    _vm._v(
                      "You're about to submit a request to be visible on Mod24 website!"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-center mt-3 px-3" }, [
                    _vm._v(
                      "\n        Our team will verify your information within the next 48h. A reply will be sent to your company email address.\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-center mt-3 px-3" }, [
                    _vm._v(
                      "\n        If you need to change any information, such as images, description, logo, licence number or payments details, it will need additional approval from our team.\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "licence_number" }
                  }),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "note" }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-center w-100 mt-3"
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-secondary mr-1 w-50 btn-decline",
                          on: {
                            click: function($event) {
                              _vm.showApprovalModal = false
                            }
                          }
                        },
                        [_vm._v("\n          No, go back.\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary ml-1 w-50 btn-accept",
                          on: { click: _vm.makeVisible }
                        },
                        [_vm._v("\n          Yes, submit.\n        ")]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("template", { slot: "footer" }, [_vm._v(" ")])
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0512f12c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0512f12c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/companies/CompaniesVisibilityBar.vue
// module id = null
// module chunks = 